import { Injectable, InjectionToken, Provider } from '@angular/core';
import { CreateApiServiceOfficeStatementBody } from '../api-types/service-office-statement.api';
import { CreateServiceOfficeStatementBody } from '../app-types/service-office-statement';
import { transformCreateServiceOfficeStatementToApiCreateServiceOfficeStatementBody } from '../transformers/service-office-statement.transform';
import { BaseRequestService } from './base-request.service';
import { ApiAssignmentWithRelations } from '../api-types/assignment.api';

export const SERVICE_OFFICE_STATEMENT_API = new InjectionToken<ServiceOfficeStatementProvider>(
	'SERVICE_OFFICE_STATEMENT_API',
);

@Injectable()
export class ServiceOfficeStatementApi extends BaseRequestService implements ServiceOfficeStatementProvider {
	public create = async (
		clientId: number | string,
		data: CreateServiceOfficeStatementBody,
		initialStatement?: boolean,
	) => {
		const body = transformCreateServiceOfficeStatementToApiCreateServiceOfficeStatementBody(data);
		return this.post<{ id: number }, CreateApiServiceOfficeStatementBody>(
			`clients/${clientId}/serviceOfficeStatements`,
			body,
			{ initialStatement },
		);
	};
	public reset = async (clientId: number | string, assignmentId: number | string) => {
		return this.post<ApiAssignmentWithRelations, unknown>(
			`clients/${clientId}/serviceOfficeStatements/${assignmentId}/reset`,
			undefined,
		);
	};
}

export const provideServiceOfficeStatementApi: Provider = {
	provide: SERVICE_OFFICE_STATEMENT_API,
	useClass: ServiceOfficeStatementApi,
};

export interface ServiceOfficeStatementProvider {
	create(
		clientId: number | string,
		data: CreateServiceOfficeStatementBody,
		initialStatement?: boolean,
	): Promise<{ id: number }>;
	reset(clientId: number | string, assignmentId: number | string): Promise<ApiAssignmentWithRelations>;
}
